module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"notificationSettigns":"Налаштування сповіщень"},"en":{"notificationSettigns":"Notification Settings"}}')
  delete Component.options._Ctor
}
